<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EPI"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>Once I moved about like the wind.</i></span></p>
<p class="EPS">—G<span class="small">OYAAŁÉ</span> (G<span class="small">ERONIMO</span>), 1886</p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?21449c82